const links = {
  Services: ['TPO Roofing', 'EPDM Rubber Roofing', 'Modified Bitumen', 'Roof Coatings', 'Emergency Repair', 'Inspections'],
  Company: ['About Us', 'Our Team', 'Certifications', 'Engineer on Staff'],
  Support: ['Free Estimate', '24-Hr Emergency', 'FAQ', 'Contact Us'],
};

export default function Footer() {
  return (
    <footer className="bg-black border-t border-white/10 py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 flex items-center justify-center bg-orange-600">
                <i className="ri-building-2-line text-white text-sm" />
              </div>
              <p className="text-base font-display font-semibold text-white">
                Commercial Roofing NJ
              </p>
            </div>
            <p className="text-sm text-gray-500 leading-relaxed max-w-xs mb-4">
              Commercial flat roofing specialists serving all of New Jersey &amp; Pennsylvania.
              Certified with major manufacturers. Engineer on staff. 24/7 emergency service.
            </p>
            <a
              href="tel:8566776191"
              className="inline-flex items-center gap-2 text-sm font-semibold text-orange-500 hover:text-orange-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-fill text-xs" />
              </span>
              (856) 677-6191
            </a>
          </div>

          {/* Links */}
          {Object.entries(links).map(([category, items]) => (
            <div key={category}>
              <p className="text-xs font-semibold text-white tracking-widest uppercase mb-4">{category}</p>
              <ul className="flex flex-col gap-2.5">
                {items.map((item) => (
                  <li key={item}>
                    <a
                      href="#"
                      className="text-sm text-gray-500 hover:text-white transition-colors cursor-pointer"
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-700">
            &copy; {new Date().getFullYear()} Commercial Roofing NJ | Serving New Jersey &amp; Pennsylvania | (856) 677-6191
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-xs text-gray-700 hover:text-gray-400 transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-xs text-gray-700 hover:text-gray-400 transition-colors cursor-pointer">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
